import { NavLink, useNavigate } from "react-router-dom";
import { Activity, Cable, Filter, Settings, LogOut, Terminal } from "lucide-react";
import { useAuth } from "@/AuthContext";
import { toast } from "sonner";

const tabs = [
    { to: "/", label: "dashboard", icon: Activity },
    { to: "/channels", label: "channels", icon: Cable },
    { to: "/rules", label: "rules", icon: Filter },
    { to: "/settings", label: "settings", icon: Settings },
];

export default function TopNav() {
    const { logout } = useAuth();
    const nav = useNavigate();

    const onLogout = async () => {
        await logout();
        toast.success("Logged out");
        nav("/login", { replace: true });
    };

    return (
        <nav
            className="panel px-4 py-3 flex items-center gap-1 mb-8 fade-in"
            data-testid="top-nav"
        >
            <div className="flex items-center gap-2 pr-4 mr-2 border-r"
                 style={{ borderColor: "var(--border)" }}>
                <Terminal size={14} style={{ color: "var(--accent)" }} />
                <span
                    className="mono text-[11px] uppercase tracking-[0.18em]"
                    style={{ color: "var(--text)" }}
                >
                    webhook<span style={{ color: "var(--text-faint)" }}>.</span>
                    <span style={{ color: "var(--accent)" }}>relay</span>
                </span>
            </div>
            <div className="flex items-center gap-1 flex-1 overflow-x-auto">
                {tabs.map(({ to, label, icon: Icon }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={to === "/"}
                        className={({ isActive }) =>
                            `mono text-[11px] uppercase tracking-[0.14em] px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                                isActive
                                    ? "text-[color:var(--accent)] bg-[rgba(124,255,203,0.06)]"
                                    : "text-[color:var(--text-dim)] hover:text-[color:var(--text)]"
                            }`
                        }
                        data-testid={`nav-${label}`}
                    >
                        <Icon size={12} />
                        {label}
                    </NavLink>
                ))}
            </div>
            <button
                onClick={onLogout}
                className="ghost-btn"
                data-testid="nav-logout-btn"
            >
                <LogOut size={12} />
                logout
            </button>
        </nav>
    );
}
